import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '美女内裤精选指南——舒适时尚兼备',
            description: '探索美女内裤的全方位选购指南，涵盖材质、款式、尺码与品牌推荐，帮助每位女性找到最适合自己的内裤。',
            url: 'https://www.example.com/',
            publisher: {
              '@type': 'Organization',
              name: '内裤精选指南',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '女士内裤多久更换一次最合适？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '一般建议内裤穿着3-6个月后更换。当发现内裤出现变形、发黄、弹性减退、面料变薄等情况时，就应及时更换。日常最好准备10-15条轮换穿着，延长每条内裤的使用寿命。',
                },
              },
              {
                '@type': 'Question',
                name: '什么材质的内裤最适合日常穿着？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '日常穿着首选纯棉内裤，透气性好、亲肤柔软，对皮肤刺激最小。莫代尔材质也是不错的选择，比纯棉更丝滑柔软，吸湿性更好。',
                },
              },
              {
                '@type': 'Question',
                name: '内裤应该手洗还是机洗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '强烈建议手洗内裤。机洗不仅容易导致内裤变形、弹性减退，还可能与外衣交叉污染。手洗时使用温和的内衣专用洗涤液，水温控制在30°C以下。',
                },
              },
              {
                '@type': 'Question',
                name: '高腰内裤和低腰内裤怎么选？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '这主要取决于你的穿着习惯和体型。高腰内裤提供更好的腹部包裹感和保暖性，适合搭配高腰裤装。低腰内裤适合搭配低腰裤装，穿着更无痕。',
                },
              },
              {
                '@type': 'Question',
                name: '运动时应该穿什么样的内裤？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '运动时建议选择专业的运动内裤，它们通常采用速干面料，具有出色的吸湿排汗性能。无痕设计可以减少运动摩擦，高弹力面料确保活动自如。',
                },
              },
              {
                '@type': 'Question',
                name: '内裤尺码选大了还是选小了更不好？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '两者都不好，但穿小了危害更大。内裤过紧会压迫腹部、影响血液循环，还可能导致私处摩擦不适。建议准确测量臀围，对照品牌尺码表选择。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}